import * as React from 'react';
import { toast } from 'react-toastify';
import * as DateHelpers from './DateHelpers';
import { useNavigate } from 'react-router-dom';
import { CheckPermissions, GetCustomers } from './Shared';
import type { GenericList } from './models/JobSharedInterfaces';

const ReportCustomerEmailsData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [customers, setCustomers] = React.useState<GenericList[]>([]);
    const [startDate, setStartDate] = React.useState("");
    const [endDate, setEndDate] = React.useState("");
    const [customerId, setCustomerId] = React.useState(-1);

    React.useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunReports");
        if (hasPermission) {
            getCustomersList();
        } else {
            navigate("/accessdenied");
        }
    }

    const getCustomersList = async () => {
        try {
            var customers: GenericList[] = await GetCustomers();
            if (customers.length === 0) {
                toast.error("Error getting customers");
            } else {
                setCustomers(customers);
                setLoading(false);
            }
        } catch (e) {
            toast.error("Error getting customers!");
        }
    }

    const handleStartDateChange = (e: any) => {
        let error = errors;
        delete error["startDate"];
        setErrors(error);

        setStartDate(e.target.value);
    }

    const handleEndDateChange = (e: any) => {
        let error = errors;
        delete error["endDate"];
        setErrors(error);

        setEndDate(e.target.value);
    }

    const handleCustomerChange = (e: any) => {
        let custId = e.target.value * 1;
        setCustomerId(custId);
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data
        runRpt();
    }

    const validate = () => {
        let error: any = {};
        let formIsValid = true;

        if (!startDate) {
            formIsValid = false;
            error["startDate"] = "Start Date is required";
        } else if (!DateHelpers.isValidDate(startDate)) {
            errors["startDate"] = "Valid Start Date is Required";
            formIsValid = false;
        }

        if (!endDate) {
            formIsValid = false;
            error["endDate"] = "End Date is required";
        } else if (!DateHelpers.isValidDate(endDate)) {
            errors["endDate"] = "Valid End Date is Required";
            formIsValid = false;
        }

        if (startDate && endDate && endDate < startDate) {
            formIsValid = false;
            error["startDate"] = "Start Date must be <= End Date";
        }

        setErrors(error);
        return formIsValid;
    }

    const runRpt = () => {
        if (validate()) {
            var url = "/report/CustomerEmails/" + startDate + "/" + endDate + "/" + customerId + "/-1/-1";
            window.open(url, '_blank');
        } else {
            toast.error("Please fix validation errors on screen before running report!");
        }
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Customer Emails Report</h1>
            </div>
            <div>
                <label className="input-group" htmlFor="startDate">
                    <span className="label">Start Date</span>
                    <input type='date' id="startDate" name="startDate" className='input' value={startDate} onChange={(e) => handleStartDateChange(e)}></input>
                </label>
                <span className={errors["startDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["startDate"]}</span>

                <label className="input-group" htmlFor="endDate">
                    <span className="label">End Date</span>
                    <input type='date' id="endDate" name="endDate" className='input' value={endDate} onChange={(e) => handleEndDateChange(e)}></input>
                </label>
                <span className={errors["endDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["endDate"]}</span>

                <label className="input-group" htmlFor="customerId">
                    <span className="label">Customer</span>
                    <select className="select" id="customerId" name="customerId" value={customerId} onChange={(e) => handleCustomerChange(e)}>
                        <option defaultValue="-1" value="-1"></option>
                        {customers.map(customer =>
                            <option key={customer.id} value={customer.id}>{customer.name}</option>
                        )};
                    </select>
                </label>

                <button className="defaultbutton marginLeftLabel" type='button' onClick={runReport}>Run Report</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

}

export default ReportCustomerEmailsData;